import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { BaseResponse } from 'src/app/models/response';
import { TokenService } from '../../../shared/services/token.service';

@Component({
  selector: 'app-logout-from-product',
  template: '<p>Logging out...</p>'
})
export class LogoutFromProductComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    if (!this.tokenService.getter()) {
      this.navigateToSessionClear();
      return;
    }

    this.authService.sovosLogout().subscribe({
      next: (response: BaseResponse) => {
        if (response.status === 'SUCCESS' && response.response?.redirectUrl) {
          window.location.href = response.response.redirectUrl;
        } else {
          this.navigateToSessionClear();
        }
      },
      error: () => this.navigateToSessionClear()
    });
  }

  private navigateToSessionClear(): void {
    this.router.navigate(['auth/logout-all-session']);
  }
}
